import { Box, Flex, Icon } from '@energiebespaarders/symbols';
import { CaretRight, Home } from '@energiebespaarders/symbols/icons/line';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import HybridLink from '~/components/HybridLink';
import { formatBreadCrumb, formatPathnames, generateUrl } from './FaqBreadCrumbs';

const DesktopBreadCrumb = styled(HybridLink)`
  &:hover {
    opacity: 70%;
  }
`;

const DesktopBreadCrumbs: React.FC = () => {
  const router = useRouter();

  const pathnames = formatPathnames(router.asPath);

  return (
    <Flex>
      <HybridLink to={'/faq'}>
        <Icon icon={Home} />
      </HybridLink>

      <Icon icon={CaretRight} mx={2} />
      {pathnames.map((p, i) => {
        const isLastItem = pathnames[pathnames.length - 1] === p;
        return p === 'faq' ? null : (
          <Box key={`crumb-${i}`}>
            <DesktopBreadCrumb style={{ color: 'black' }} to={generateUrl(p, pathnames)}>
              {formatBreadCrumb(p)}
            </DesktopBreadCrumb>

            {!isLastItem && <Icon icon={CaretRight} mx={2} />}
          </Box>
        );
      })}
    </Flex>
  );
};

export default DesktopBreadCrumbs;
